import React from 'react';
import Header from './../common/Header.jsx';
import Footer from './../common/Footer.jsx';
import { Route, Switch,HashRouter} from 'react-router-dom';
import Index from './components/Index.jsx';
import Detail from './components/Detail.jsx';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import '../epsicon/style.css';


const BasicRoute = () => (
    <HashRouter>
        <Header />
        <Switch>
            <Route exact path="/" component={Index} />
            <Route exact path="/detail/:id" component={Detail} />
        </Switch>
        <Footer />
    </HashRouter>
);

function App() {
	return (
        <ConfigProvider locale={zhCN}>
		    <BasicRoute />
        </ConfigProvider>
	);
}

export default App;
